import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { Approval } from '@portal-front-end/models';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Update } from '@ngrx/entity';

@Injectable({ providedIn: 'root' })

export class ApprovalsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly APPROVAL_API_URL = `${this.apiServer}/approvals`;

    getApprovals(): Observable<Approval[]> {
        return this.http.get<Approval[]>(`${this.APPROVAL_API_URL}`);
    }

    putApprovals(payload: Update<Approval>): Observable<Approval> {
        return this.http.put<Approval>(`${this.APPROVAL_API_URL}/${payload.changes.approvalId}`, payload.changes);
    }
}
